module.exports = __webpack_public_path__ + "img/img_shouye_zijin_one@2x.90d436af.png";